import { Row } from "./row";

function isNumeric(n: any): n is number {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export interface VoteJSON {
  id: number;

  user_id: number;
  compo_id: number;
  entry_id: number;
  public: boolean;
  review: string;
  review_favorites: number;
  ignored: boolean;

  created: Date;
  updated_at: Date;

  anonymous: boolean;

  guess: string;
  guess_score: number;

  custom1: number | undefined;
  custom2: number | undefined;
  custom3: number | undefined;
  custom4: number | undefined;
  custom5: number | undefined;
  custom6: number | undefined;
  custom7: number | undefined;
  custom8: number | undefined;
  custom9: number | undefined;
}

export class Vote extends Row<VoteJSON> implements VoteJSON {
  declare id: number;

  declare created: Date;
  declare updated_at: Date;

  declare public: boolean;
  declare review: string;
  declare user_id: number;
  declare compo_id: number;
  declare entry_id: number;
  declare anonymous: boolean;
  declare guess: string;
  declare guess_score: number;

  declare ignored: boolean;
  declare review_favorites: number;

  declare custom1: number | undefined;
  declare custom2: number | undefined;
  declare custom3: number | undefined;
  declare custom4: number | undefined;
  declare custom5: number | undefined;
  declare custom6: number | undefined;
  declare custom7: number | undefined;
  declare custom8: number | undefined;
  declare custom9: number | undefined;

  declare overall: number | undefined; // OLD STYLE VOTE DO NOT USE PL0X
  declare production: number | undefined;
  declare atmosphere: number | undefined;
  declare sounddesign: number | undefined;
  declare composition: number | undefined;
  declare arrangement: number | undefined;
  declare uniqueness: number | undefined;
  declare theme: number | undefined;

  constructor(props: VoteJSON) {
    super(props);
  }

  get votes(): number[] {
    /**
     * The really annoying thing is the server currently returns 0 in the case
     * of a non score (e.g. not that many categories), which is obviously
     * indistinguishable from a 0. So this is the best we can do currently.
     */
    if (isNumeric(this.overall) || isNumeric(this.uniqueness)) {
      // support "legacy" votes.

      return [
        this.overall || 0,
        this.production || 0,
        this.composition || 0,
        this.arrangement || 0,
        this.atmosphere || 0,
        this.sounddesign || 0,
        this.uniqueness || 0,
        this.theme || 0,
      ];
    }

    return [
      this.custom1 ? this.custom1 : 0,
      this.custom2 ? this.custom2 : 0,
      this.custom3 ? this.custom3 : 0,
      this.custom4 ? this.custom4 : 0,
      this.custom5 ? this.custom5 : 0,
      this.custom6 ? this.custom6 : 0,
      this.custom7 ? this.custom7 : 0,
      this.custom8 ? this.custom8 : 0,
      this.custom9 ? this.custom9 : 0,
    ];
  }
}

export function IsVote(x: any): x is VoteJSON {
  return x.id && x.created && typeof x.custom1 === "number";
}
